export default {
      id: "location-point-usage",
      viewBox: "0 0 12 17",
      url: __webpack_public_path__ + "img/icons.svg#location-point",
      toString: function () {
        return this.url;
      }
    }